import TemplateString from './TemplateString';
import './template-string.scss';

export default TemplateString;
